import { RoomField } from '../../../../system/field';

export type ExpandedState = Record<string, boolean>;

export enum LevelType {
  UPPER = 'Upper',
  MAIN = 'Main',
  LOWER = 'Lower',
  UNSPECIFIED = 'Unspecified',
}

export interface Room {
  [RoomField.ROOM_KEY]: string;
  [RoomField.ROOM_TYPE]: string;
  [RoomField.ROOM_ITEM_NUMBER]: number;
  [RoomField.ROOM_LENGTH]: number;
  [RoomField.ROOM_WIDTH]: number;
  [RoomField.ROOM_LEVEL]: string;
  [RoomField.ROOM_DISPLAY_ORDER]: number;
  [RoomField.ROOM_FEATURES]: string[];
  [RoomField.ROOM_DESCRIPTION]?: string | null;
}

export interface RoomGroupType {
  label: string;
  type: string;
  groupWith?: string[];
  count?: number;
}

export interface LevelCounts {
  bedrooms: number;
  fullBaths: number;
  halfBaths: number;
  hasRoom: boolean;
}

export interface RoomSummary {
  levels: number;
  totalFullBaths: number;
  totalHalfBaths: number;
  totalBedrooms: number;
  totalRooms: number;
  totalBathrooms: number;
  storyList: string[];
  upperLevels: { [key: number]: LevelCounts };
  lowerLevels: { [key: number]: LevelCounts };
  mainLevel: LevelCounts;
}

export interface DragItem {
  key: string;
  index: number;
  itemNumber: number;
}

export const RoomGroups: RoomGroupType[] = [
  {
    label: 'Bedroom',
    type: 'Bedroom',
  },
  {
    label: 'Full Bathroom',
    type: 'Bathroom',
    groupWith: ['Full Bath'],
  },
  {
    label: 'Half Bathroom',
    type: 'Half Bath',
  },
];
